import { defaultVhcItems } from './vhc/model/utils';
import { VHCRecordItemGroups } from 'api/generated';
import { useGetVhcRecordLaboursQuery } from 'features/vhc/api/get-labours';
import { useGetVhcRecordPartsQuery } from 'features/vhc/api/get-parts';
import { useGetVhcRecordQuery } from 'features/vhc/api/get-record';
import { useWaitingStore } from 'features/vhc/modals/record/forms/vhc-record/waiting-context';
import { useVhcRecordStoreStore } from 'features/vhc/modals/record/vhc-record.store';
import { useRecordStore, VhcItemFormType } from 'features/vhc/model';
import { useEffect } from 'react';

interface IProps {
  id: string;
}

export const useVhcRecord = ({ id }: IProps) => {
  const setIsWaiting = useWaitingStore((s) => s.setIsWaiting);
  const setBranch = useVhcRecordStoreStore((x) => x.setBranch);
  const {
    data: vhcData,
    isLoading: isLoadingRecord,
    refetch,
    isFetching: isFetchingRecord
  } = useGetVhcRecordQuery({ id: Number(id) });
  const {
    data: laboursData,
    refetch: refetchLabours,
    isLoading: isLoadingLabours
  } = useGetVhcRecordLaboursQuery(Number(id));
  const { data: partsData, refetch: refetchParts, isLoading: isLoadingParts } = useGetVhcRecordPartsQuery(Number(id));

  const isLoading = isLoadingRecord || isLoadingLabours || isLoadingParts;

  useEffect(() => {
    setIsWaiting(isFetchingRecord);
  }, [isFetchingRecord]);

  useEffect(() => {
    setIsWaiting(isLoadingLabours);
  }, [isLoadingLabours]);

  useEffect(() => {
    setIsWaiting(isLoadingParts);
  }, [isLoadingParts]);

  const { setGeneralData, setItems, generalData } = useRecordStore();

  useEffect(() => {
    setBranch(vhcData?.generalData.branch);
    setGeneralData(vhcData?.generalData || {});
    setItems(
      vhcData?.items?.map((item) => {
        let formType: VhcItemFormType = 'default';

        if (item.group === VHCRecordItemGroups.BrakesAndHubs) formType = 'brake';
        if (item.group === VHCRecordItemGroups.WheelsAndTyres) formType = 'wheelTyre';

        if (item.parts == null) {
          item.parts = [];
        }

        if (item.labours == null) {
          item.labours = [];
        }

        return { ...item, formType };
      }) || defaultVhcItems
    );
  }, [vhcData]);

  return {
    vhcData,
    laboursData,
    partsData,
    generalData,
    isLoading,
    refetch,
    refetchLabours,
    refetchParts,
    isLoadingLabours,
    isLoadingParts
  };
};
